/**
 * 运营弹窗场景闭集（ADM-OPS-S007）—— slug ↔ 中文名的单一来源。
 *
 * 闭集由契约固定（dev-docs `02-API契约/A2-运营配置.md` §5.2 + DB CHECK 双层）：运营创造不出
 * 第四个场景，故这里是常量表而非配置。原先挂在 OpsPopupSceneDialog 上，该弹窗随「只留上下架」
 * 收敛被删除后移到这里 —— 运营弹窗 Tab 与系统设置的弹窗权限档都从这一份取，不各写一份。
 */

import type { OperationalPopupScenario } from '@novel-admin/shared';

export const POPUP_SCENARIO_OPTIONS: { value: OperationalPopupScenario; label: string }[] = [
  { value: 'payment_exit_retention', label: '支付退出挽留' },
  { value: 'first_purchase_offer', label: '首充优惠弹窗' },
  { value: 'insufficient_balance_offer', label: '余额不足优惠' },
];

/** 未知 slug 原样返回：闭集之外的值只可能来自库里的脏数据，不掩盖成某个已知场景 */
export function scenarioLabel(scenario: string): string {
  return POPUP_SCENARIO_OPTIONS.find((o) => o.value === scenario)?.label ?? scenario;
}
